import React, { useEffect, useState } from "react";
import "./table.css";
//import instituciones from "../../json/instituciones.json"
import { API_BASE_URL } from "../../Config/config";
import axios from "axios";
import { Link } from "react-router-dom";
import Loading from "../shared/Loading/Loading";
import { duracionEntrevistaCardHome, duracionEntrevistaGetPeriodo, apiDownloadExcelHome } from "../../service/Service";


const DataTableDuracionEntrevista = () => {
  function TabPane({ children, value, index }) {
    return (
        <div role="tabpanel" hidden={value !== index} style={{ marginTop: '20px' }}>
            {value === index && (
              <div>{children}</div>
            )}
        </div>
    );
  }

  function Tabs({ children }) {
    const [value, setValue] = useState(0);

    return (
        <div>
            <div>
                {React.Children.map(children, (child, index) => (
                    <button 
                        onClick={() => setValue(index)}
                        style={{
                            cursor: 'pointer',
                            padding: '10px 20px',
                            margin: '0 5px',
                            border: 'none',
                            borderRadius: '5px',
                            backgroundColor: value === index ? '#4CAF50' : '#E0E0E0',
                            color: value === index ? 'white' : 'black',
                            fontWeight: value === index ? 'bold' : 'normal'
                        }}
                    >
                        {child.props.label}
                    </button>
                ))}
            </div>
            <div>
                {React.Children.map(children, (child, index) => {
                    return React.cloneElement(child, { value, index });
                })}
            </div>
        </div>
    );
  }

  // const [dataTable, setDataTable] = useState([]);
  const [cardsHome, setCardsHome] = useState([]);
  const [cardsCati, setCardsCati] = useState([]);
  const [cardsWeb, setCardsWeb] = useState([]);

  const [dataTabla, setDataTabla] = useState([]);
  const [dataTablaCati, setDataTablaCati] = useState([]);
  const [dataTablaWeb, setDataTablaWeb] = useState([]);

  const [isloading, setIsLoading] = useState(false);
  const [isloadingtabla, setIsLoadingtabla] = useState(false);

  useEffect(() => {
    const fetchcard = async () => {
      setIsLoading(true);
      try {
        const {data, status} = await duracionEntrevistaCardHome();
        const {total, integra, limesurvey} = data.data;
        setCardsHome(total);
        setCardsCati(integra);
        setCardsWeb(limesurvey);
      } catch (error) {
        // Manejo de errores
      }
      setIsLoading(false);
    };

    const fetchDias = async () => {
      setIsLoadingtabla(true);

      try {
        const {data, status} = await duracionEntrevistaGetPeriodo();
        const {total, integra, limesurvey} = data.data;
        setDataTabla(total);
        setDataTablaCati(integra);
        setDataTablaWeb(limesurvey);
      } catch (error) {
        // Manejo de errores
      }

      setIsLoadingtabla(false);
    };

    fetchDias();
    fetchcard();
  }, [])

  const downloadExcelHome = () => {
    apiDownloadExcelHome().then((res) => {
      if ( parseInt(res.status) === 200 ) {
        const {status, msg, data} = res.data;
        if (parseInt(status) === 200 ) {
          console.log(msg);
          window.open(data.url, '_blank');
        } else {
          console.log('Ocurrió un error al descargar los datos.', msg);
        }
      }
    });
  }
  
  return (
    <div style={{ width: "90%", margin: "20px auto" }}>
      <Tabs>
          <TabPane label="TOTAL">
            <div className="row" style={{ paddingTop: 20 }}>
              <div className="col-sm-4 mb-3 mb-sm-0" style={{ paddingLeft: 100 }}>
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Media</h5>
                    {isloading ? (
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                    ) : (
                      <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHome.media}</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Mínimo</h5>
                    {isloading ? (
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                    ) : (
                      <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHome.minimo}</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-sm-4" style={{ paddingRight: 100 }}>
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Máximo</h5>
                    {isloading ? (
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                    ) : (
                      <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHome.maximo}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table custom-table table-hover table-striped ">
                <thead className="titles">
                  <tr>
                    <th scope="col" style={{verticalAlign:"middle", width:"414,9"}}>Percentil</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"15%"}}>25</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"15%"}}>50</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"15%"}}>75</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"15%"}}>90</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-center">Resultado</td>
                    <td className="text-center">{cardsHome.p25}</td>
                    <td className="text-center">{cardsHome.p50}</td>
                    <td className="text-center">{cardsHome.p75}</td>
                    <td className="text-center">{cardsHome.p90}</td></tr>
                </tbody>
              </table>
            </div>
            <div className="table-responsive">
              <table className="table custom-table table-hover table-striped ">
                <thead className="titles">
                  <tr>
                    <th scope="col" style={{verticalAlign:"middle"}}>Período</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"10%"}}>Media</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"10%"}}>Mínimo</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"10%"}}>Máximo</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"10%"}}>P25</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"10%"}}>P50</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"10%"}}>P75</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"10%"}}>P90</th>
                  </tr>
                </thead>
                <tbody>
                  {isloadingtabla ? (
                    <tr>
                      <td className="text-center" colSpan="8">
                        <div className="d-flex justify-content-center">
                          <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                          </div>
                        </div>
                      </td>
                    </tr>
                  ) : dataTabla.map((item, index) => {
                      return (
                        <tr key={`total_${index}`}>
                          <th className="text-center">
                            {item.label}
                          </th>
                          <th className="text-center">{item.media}</th>
                          <th className="text-center">{item.minimo}</th>
                          <th className="text-center">{item.maximo}</th>
                          <th className="text-center">{item.p25}</th>
                          <th className="text-center">{item.p50}</th>
                          <th className="text-center">{item.p75}</th>
                          <th className="text-center">{item.p90}</th> 
                        </tr>)
                    })}
                </tbody>
              </table>
            </div>
            <div style={{ textAlign: "right", paddingRight: 100 }}>
              <button className="btn btn-primary" onClick={downloadExcelHome}>
                Descargar Excel
              </button>
            </div>
            <br/>
            <br/>
          </TabPane>
          <TabPane label="CATI">
            <div className="row" style={{ paddingTop: 20 }}>
              <div className="col-sm-4 mb-3 mb-sm-0" style={{ paddingLeft: 100 }}>
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Media</h5>
                    {isloading ? (
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                    ) : (
                      <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsCati.media}</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Mínimo</h5>
                    {isloading ? (
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                    ) : (
                      <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsCati.minimo}</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-sm-4" style={{ paddingRight: 100 }}>
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Máximo</h5>
                    {isloading ? (
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                    ) : (
                      <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsCati.maximo}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table custom-table table-hover table-striped ">
                <thead className="titles">
                  <tr>
                    <th scope="col" style={{verticalAlign:"middle", width:"414,9"}}>Percentil</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"15%"}}>25</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"15%"}}>50</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"15%"}}>75</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"15%"}}>90</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-center">Resultado</td>
                    <td className="text-center">{cardsHome.p25}</td>
                    <td className="text-center">{cardsHome.p50}</td>
                    <td className="text-center">{cardsHome.p75}</td>
                    <td className="text-center">{cardsHome.p90}</td></tr>
                </tbody>
              </table>
            </div>
            <div className="table-responsive">
              <table className="table custom-table table-hover table-striped ">
                <thead className="titles">
                  <tr>
                    <th scope="col" style={{verticalAlign:"middle"}}>Período</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"10%"}}>Media</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"10%"}}>Mínimo</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"10%"}}>Máximo</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"10%"}}>P25</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"10%"}}>P50</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"10%"}}>P75</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"10%"}}>P90</th>
                  </tr>
                </thead>
                <tbody>
                  {isloadingtabla ? (
                    <tr>
                      <td className="text-center" colSpan="8">
                        <div className="d-flex justify-content-center">
                          <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                          </div>
                        </div>
                      </td>
                    </tr>
                  ) : dataTablaCati.map((item, index) => {
                      return (
                        <tr key={`total_${index}`}>
                          <th className="text-center">
                            {item.label}
                          </th>
                          <th className="text-center">{item.media}</th>
                          <th className="text-center">{item.minimo}</th>
                          <th className="text-center">{item.maximo}</th>
                          <th className="text-center">{item.p25}</th>
                          <th className="text-center">{item.p50}</th>
                          <th className="text-center">{item.p75}</th>
                          <th className="text-center">{item.p90}</th> 
                        </tr>)
                    })}
                </tbody>
              </table>
            </div>
            <div style={{ textAlign: "right", paddingRight: 100 }}>
              <button className="btn btn-primary" onClick={downloadExcelHome}>
                Descargar Excel
              </button>
            </div>
            <br/>
            <br/>
          </TabPane>
          <TabPane label="WEB">
            <div className="row" style={{ paddingTop: 20 }}>
              <div className="col-sm-4 mb-3 mb-sm-0" style={{ paddingLeft: 100 }}>
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Media</h5>
                    {isloading ? (
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                    ) : (
                      <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsWeb.media}</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Mínimo</h5>
                    {isloading ? (
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                    ) : (
                      <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsWeb.minimo}</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-sm-4" style={{ paddingRight: 100 }}>
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Máximo</h5>
                    {isloading ? (
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                    ) : (
                      <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsWeb.maximo}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table custom-table table-hover table-striped ">
                <thead className="titles">
                  <tr>
                    <th scope="col" style={{verticalAlign:"middle", width:"414,9"}}>Percentil</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"15%"}}>25</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"15%"}}>50</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"15%"}}>75</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"15%"}}>90</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-center">Resultado</td>
                    <td className="text-center">{cardsWeb.p25}</td>
                    <td className="text-center">{cardsWeb.p50}</td>
                    <td className="text-center">{cardsWeb.p75}</td>
                    <td className="text-center">{cardsWeb.p90}</td></tr>
                </tbody>
              </table>
            </div>
            <div className="table-responsive">
              <table className="table custom-table table-hover table-striped ">
                <thead className="titles">
                  <tr>
                    <th scope="col" style={{verticalAlign:"middle"}}>Período</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"10%"}}>Media</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"10%"}}>Mínimo</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"10%"}}>Máximo</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"10%"}}>P25</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"10%"}}>P50</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"10%"}}>P75</th>
                    <th scope="col" style={{verticalAlign:"middle", width:"10%"}}>P90</th>
                  </tr>
                </thead>
                <tbody>
                  {isloadingtabla ? (
                    <tr>
                      <td className="text-center" colSpan="8">
                        <div className="d-flex justify-content-center">
                          <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                          </div>
                        </div>
                      </td>
                    </tr>
                  ) : dataTablaWeb.map((item, index) => {
                      return (
                        <tr key={`total_${index}`}>
                          <th className="text-center">
                            {item.label}
                          </th>
                          <th className="text-center">{item.media}</th>
                          <th className="text-center">{item.minimo}</th>
                          <th className="text-center">{item.maximo}</th>
                          <th className="text-center">{item.p25}</th>
                          <th className="text-center">{item.p50}</th>
                          <th className="text-center">{item.p75}</th>
                          <th className="text-center">{item.p90}</th> 
                        </tr>)
                    })}
                </tbody>
              </table>
            </div>
            <div style={{ textAlign: "right", paddingRight: 100 }}>
              <button className="btn btn-primary" onClick={downloadExcelHome}>
                Descargar Excel
              </button>
            </div>
            <br/>
            <br/>
          </TabPane>
      </Tabs>
    </div>
  );
};

export default DataTableDuracionEntrevista;
